import React, { useEffect, useRef, useState } from 'react'
import BookingFilter from './BookingFilter'
import { Col, Row } from 'antd'
import BookingFlight from './BookingFlight'
import { fetchTboMeaData, getConvenienceCharge, getFlightDetailsTBO } from '../../../services/flight/flightServices'
import FlightNotFetch from './FlightNotFetch'

const BookingDetailsTbo = ({ location }) => {
    const [flightDetails, setflightDetails] = useState([]);
    const [loading, setLoading] = useState(null)
    const [messageData, setMessageData] = useState("");
    const [isModalOpenFlightNotFetch, setIsModalOpenFlightNotFetch] = useState(false);
    const [meelBaggegasData, setMeelBaggegasData] = useState(null);
    const [errorMeelBaggegas, setMeelBaggegasError] = useState(null);
    const bookingFilterRef = useRef();

    useEffect(() => {
        const fetchData = async () => {
            const flightDetailsId = location?.state?.traceId;
            let payload;

            if (location?.state && location?.state?.selectedCards) {
                payload = {
                    TraceId: flightDetailsId,
                    ResultIndex: [location?.state?.selectedCards, location?.state?.selectedCardReturn]
                };
            } else {
                payload = {
                    TraceId: flightDetailsId,
                    ResultIndex: [location?.state?.ResultIndex]
                };
            }
            setLoading(true);
            try {
                const flightResp = await getFlightDetailsTBO(payload);
                setflightDetails(flightResp?.data);
                fetchTboMeaData(payload)
                    .then((mealResp) => {
                        setMeelBaggegasData(mealResp);
                    })
                    .catch((mealErr) => {
                        console.error("Error fetching flight meal-------------", mealErr?.response?.data?.message);
                        setMeelBaggegasError(mealErr?.response?.data?.message);
                    });

            } catch (flightErr) {
                console.error("Flight details error:", flightErr);
                setMessageData(flightErr?.response?.data?.message);
                setLoading(false);
                setIsModalOpenFlightNotFetch(true)
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    const [selectedBaggages, setSelectedBaggages] = useState({});
    const [totalAmount, setTotalAmount] = useState(0);
    const [selectedMealsReturn, setSelectedMealsReturn] = useState([]);
    const [mealTotalAmountRetrun, setMealTotalAmountReturn] = useState(0);
    const totalSelectedTravellers = (flightDetails?.flightDetails?.fareRules?.ADULT || 0) + (flightDetails?.flightDetails?.fareRules?.CHILD || 0);
    const [selectedMeals, setSelectedMeals] = useState({});
    const [mealTotalAmount, setMealTotalAmount] = useState(0);

    const [rowsByFlight, setRowsByFlight] = useState({});
    const [legends, setLegends] = useState({});
    const [selectedSeats, setSelectedSeats] = useState({});
    const [totalPrice, setTotalPrice] = useState({});

    const [rowsByFlightReturn, setRowsByFlightReturn] = useState({});
    const [legendsReturn, setLegendsReturn] = useState({});
    const [selectedSeatsReturn, setSelectedSeatsReturn] = useState({});
    const [totalPriceReturn, setTotalPriceReturn] = useState({});

    // const handleSeatClick = (seat, flightKey) => {
    //     const currentSeats = selectedSeats[flightKey] || [];
    //     const isSelected = currentSeats.find((s) => s.Code === seat.Code);
    //     if (!seat.Available && !isSelected) return;

    //     if (isSelected) {
    //         const updatedSeats = currentSeats.filter((s) => s.Code !== seat.Code);
    //         setSelectedSeats({
    //             ...selectedSeats,
    //             [flightKey]: updatedSeats,
    //         });
    //         setTotalPrice({
    //             ...totalPrice,
    //             [flightKey]: (totalPrice[flightKey] || 0) - seat.Price,
    //         });
    //     } else {
    //         if (currentSeats.length >= totalSelectedTravellers) {
    //             alert(`You can select only ${totalSelectedTravellers} seats for this flight.`);
    //             return;
    //         }
    //         const updatedSeats = [...currentSeats, seat];
    //         setSelectedSeats({
    //             ...selectedSeats,
    //             [flightKey]: updatedSeats,
    //         });
    //         setTotalPrice({
    //             ...totalPrice,
    //             [flightKey]: (totalPrice[flightKey] || 0) + seat.Price,
    //         });
    //     }
    //     setRowsByFlight({
    //         ...rowsByFlight,
    //         [flightKey]: [...rowsByFlight[flightKey]],
    //     });
    // };

    //    const handleSeatClickReturn = (seat, flightKey) => {
    //     const currentSeats = selectedSeatsReturn[flightKey] || [];
    //     const isSelected = currentSeats.find((s) => s.Code === seat.Code);
    //     if (!seat.Available && !isSelected) return;
    //     if (isSelected) {
    //         const updatedSeats = currentSeats.filter((s) => s.Code !== seat.Code);
    //         setSelectedSeatsReturn({
    //             ...selectedSeatsReturn,
    //             [flightKey]: updatedSeats,
    //         });
    //         setTotalPriceReturn({
    //             ...totalPriceReturn,
    //             [flightKey]: (totalPriceReturn[flightKey] || 0) - seat.Price,
    //         });
    //     } else {
    //         if (currentSeats.length >= totalSelectedTravellers) {
    //             alert(`You can select only ${totalSelectedTravellers} seats for this flight.`);
    //             return;
    //         }
    //         const updatedSeats = [...currentSeats, seat];
    //         setSelectedSeatsReturn({
    //             ...selectedSeatsReturn,
    //             [flightKey]: updatedSeats,
    //         });
    //         setTotalPriceReturn({
    //             ...totalPriceReturn,
    //             [flightKey]: (totalPriceReturn[flightKey] || 0) + seat.Price,
    //         });
    //     }
    // };

    const handleSeatClick = (seat, flightKey) => {
        const currentSeats = selectedSeats[flightKey] || [];
        const isSelected = currentSeats.find((s) => s.Code === seat.Code);

        if (!seat.Available && !isSelected) return;

        if (isSelected) {
            const updatedSeats = currentSeats.filter((s) => s.Code !== seat.Code);
            setSelectedSeats({
                ...selectedSeats,
                [flightKey]: updatedSeats,
            });
            setTotalPrice({
                ...totalPrice,
                [flightKey]: (totalPrice[flightKey] || 0) - seat.Price,
            });
        } else {
            let updatedSeats = [];
            let updatedPrice = (totalPrice[flightKey] || 0);

            if (totalSelectedTravellers === 1) {
                updatedSeats = [seat];
                updatedPrice = seat.Price;
            } else {
                if (currentSeats.length >= totalSelectedTravellers) {
                    updatedSeats = [...currentSeats.slice(1), seat];
                    updatedPrice =
                        updatedSeats.reduce((sum, s) => sum + s.Price, 0);
                } else {
                    updatedSeats = [...currentSeats, seat];
                    updatedPrice = updatedPrice + seat.Price;
                }
            }

            setSelectedSeats({
                ...selectedSeats,
                [flightKey]: updatedSeats,
            });

            setTotalPrice({
                ...totalPrice,
                [flightKey]: updatedPrice,
            });
        }

        // ✅ Force re-render of rows
        setRowsByFlight({
            ...rowsByFlight,
            [flightKey]: [...rowsByFlight[flightKey]],
        });
    };

    const handleSeatClickReturn = (seat, flightKey) => {
        const currentSeats = selectedSeatsReturn[flightKey] || [];
        const isSelected = currentSeats.find((s) => s.Code === seat.Code);

        if (!seat.Available && !isSelected) return;

        if (isSelected) {
            const updatedSeats = currentSeats.filter((s) => s.Code !== seat.Code);
            setSelectedSeatsReturn({
                ...selectedSeatsReturn,
                [flightKey]: updatedSeats,
            });
            setTotalPriceReturn({
                ...totalPriceReturn,
                [flightKey]: (totalPriceReturn[flightKey] || 0) - seat.Price,
            });
        } else {
            let updatedSeats = [];
            let updatedPrice = (totalPriceReturn[flightKey] || 0);

            if (totalSelectedTravellers === 1) {
                updatedSeats = [seat];
                updatedPrice = seat.Price;
            } else {
                if (currentSeats.length >= totalSelectedTravellers) {
                    updatedSeats = [...currentSeats.slice(1), seat];
                    updatedPrice =
                        updatedSeats.reduce((sum, s) => sum + s.Price, 0);
                } else {
                    updatedSeats = [...currentSeats, seat];
                    updatedPrice = updatedPrice + seat.Price;
                }
            }

            setSelectedSeatsReturn({
                ...selectedSeatsReturn,
                [flightKey]: updatedSeats,
            });

            setTotalPriceReturn({
                ...totalPriceReturn,
                [flightKey]: updatedPrice,
            });
        }
        setRowsByFlight({
            ...rowsByFlight,
            [flightKey]: [...rowsByFlight[flightKey]],
        });
    };

    const totalSeatsPrice = Object.values(totalPrice).reduce((acc, val) => acc + val, 0);
    const totalSeatsPriceReturn = Object.values(totalPriceReturn).reduce((acc, val) => acc + val, 0);

    const addMeal = (route, mealIndex, meal) => {
        setSelectedMeals((prevState) => {
            const currentMeals = prevState[route]?.selectedMeals || [];
            const totalSelected = currentMeals.reduce((sum, m) => sum + (m.Quantity || 1), 0);
            if (totalSelected >= totalSelectedTravellers) return prevState;

            const existingMealIndex = currentMeals.findIndex((m) => m.mealIndex === mealIndex);
            let updatedMeals;

            if (existingMealIndex >= 0) {
                updatedMeals = [...currentMeals];
                updatedMeals[existingMealIndex] = {
                    ...updatedMeals[existingMealIndex],
                    Quantity: (updatedMeals[existingMealIndex].Quantity || 1) + 1,
                };
            } else {
                updatedMeals = [...currentMeals, { mealIndex, ...meal, Quantity: 1 }];
            }
            const totalPrice = Object.values({
                ...prevState,
                [route]: { selectedMeals: updatedMeals },
            }).reduce((acc, r) => {
                return (
                    acc +
                    r.selectedMeals.reduce(
                        (sum, m) => sum + m.Price * (m.Quantity || 1),
                        0
                    )
                );
            }, 0);

            setMealTotalAmount(totalPrice);
            if (bookingFilterRef.current) {
                bookingFilterRef.current.handleRemoveCode();
            }
            return {
                ...prevState,
                [route]: { selectedMeals: updatedMeals },
            };
        });
    };

    const removeMeal = (route, mealIndex) => {
        setSelectedMeals((prevState) => {
            const currentMeals = prevState[route]?.selectedMeals || [];
            const existingMealIndex = currentMeals.findIndex((m) => m.mealIndex === mealIndex);
            if (existingMealIndex < 0) return prevState;

            let updatedMeals;
            const existingMeal = currentMeals[existingMealIndex];
            const currentQty = existingMeal.Quantity || 1;

            if (currentQty > 1) {
                updatedMeals = [...currentMeals];
                updatedMeals[existingMealIndex] = { ...existingMeal, Quantity: currentQty - 1 };
            } else {
                updatedMeals = currentMeals.filter((m) => m.mealIndex !== mealIndex);
            }
            const totalPrice = Object.values({
                ...prevState,
                [route]: { selectedMeals: updatedMeals },
            }).reduce((acc, r) => {
                return (
                    acc +
                    r.selectedMeals.reduce(
                        (sum, m) => sum + m.Price * (m.Quantity || 1),
                        0
                    )
                );
            }, 0);
            setMealTotalAmount(totalPrice);
            if (bookingFilterRef.current) {
                bookingFilterRef.current.handleRemoveCode();
            }
            return {
                ...prevState,
                [route]: { selectedMeals: updatedMeals },
            };
        });
    };

    const meals = Object.values(selectedMeals).flatMap(
        (item) => item.selectedMeals
    );

    const baggages = Object.values(selectedBaggages).flatMap((baggageArray) =>
        baggageArray.map((baggage) => ({
            ...baggage,
        }))
    );

    const seats = Object?.values(selectedSeats)
        .flat()
        .map(seat => ({ ...seat, Quantity: 1 }));

    const outputData = {
        meals,
        baggages,
        seats
    };

    const getTotalSelectedBaggages = (routeIndex) => {
        return (
            selectedBaggages[routeIndex]?.reduce(
                (sum, b) => sum + (b.Quantity || 0),
                0
            ) || 0
        );
    };

    const addBaggage = (routeIndex, baggage) => {
        setSelectedBaggages((prev) => {
            const currentRouteBaggages = prev[routeIndex] || [];
            const existingIndex = currentRouteBaggages.findIndex(
                (item) => item.Weight === baggage.Weight && item.Price === baggage.Price
            );
            let updatedRouteBaggages;
            if (existingIndex >= 0) {
                updatedRouteBaggages = [...currentRouteBaggages];
                updatedRouteBaggages[existingIndex] = {
                    ...updatedRouteBaggages[existingIndex],
                    Quantity: (updatedRouteBaggages[existingIndex].Quantity || 1) + 1,
                };
            } else {
                updatedRouteBaggages = [...currentRouteBaggages, { ...baggage, Quantity: 1 }];
            }
            const updatedAllRoutes = { ...prev, [routeIndex]: updatedRouteBaggages };
            const totalPrice = Object.values(updatedAllRoutes).reduce((acc, r) => {
                return acc + r.reduce((sum, m) => sum + (m.Price || 0) * (m.Quantity || 1), 0);
            }, 0);

            setTotalAmount(totalPrice);
            if (bookingFilterRef.current) {
                bookingFilterRef.current.handleRemoveCode();
            }

            return updatedAllRoutes;
        });
    };

    const removeBaggage = (routeIndex, baggage) => {
        setSelectedBaggages((prev) => {
            if (!prev[routeIndex]) return prev;

            const currentRouteBaggages = prev[routeIndex];
            const existingIndex = currentRouteBaggages.findIndex(
                (item) => item.Weight === baggage.Weight && item.Price === baggage.Price
            );
            if (existingIndex < 0) return prev;
            let updatedRouteBaggages;
            const existing = currentRouteBaggages[existingIndex];
            const currentQty = existing.Quantity || 1;

            if (currentQty > 1) {
                updatedRouteBaggages = [...currentRouteBaggages];
                updatedRouteBaggages[existingIndex] = {
                    ...existing,
                    Quantity: currentQty - 1,
                };
            } else {
                updatedRouteBaggages = currentRouteBaggages.filter((_, idx) => idx !== existingIndex);
            }
            const updatedAllRoutes =
                updatedRouteBaggages.length === 0
                    ? Object.fromEntries(Object.entries(prev).filter(([i]) => +i !== routeIndex))
                    : { ...prev, [routeIndex]: updatedRouteBaggages };

            const totalPrice = Object.values(updatedAllRoutes).reduce((acc, r) => {
                return acc + r.reduce((sum, m) => sum + (m.Price || 0) * (m.Quantity || 1), 0);
            }, 0);
            setTotalAmount(totalPrice);
            if (bookingFilterRef.current) {
                bookingFilterRef.current.handleRemoveCode();
            }
            return updatedAllRoutes;
        });
    };

    const addMealReturn = (route, mealIndex, meal) => {
        setSelectedMealsReturn((prevState) => {
            const currentMeals = prevState[route]?.selectedMealsReturn || [];
            const totalSelected = currentMeals.reduce((sum, m) => sum + (m.Quantity || 1), 0);
            if (totalSelected >= totalSelectedTravellers) return prevState;
            const existingMealIndex = currentMeals.findIndex((m) => m.mealIndex === mealIndex);
            let updatedMeals;
            if (existingMealIndex >= 0) {
                updatedMeals = [...currentMeals];
                updatedMeals[existingMealIndex] = {
                    ...updatedMeals[existingMealIndex],
                    Quantity: (updatedMeals[existingMealIndex].Quantity || 1) + 1,
                };
            } else {
                updatedMeals = [...currentMeals, { mealIndex, ...meal, Quantity: 1 }];
            }

            const totalPrice = Object.values({
                ...prevState,
                [route]: { selectedMealsReturn: updatedMeals },
            }).reduce((acc, r) => {
                return (
                    acc +
                    r.selectedMealsReturn.reduce(
                        (sum, m) => sum + m.Price * (m.Quantity || 1),
                        0
                    )
                );
            }, 0);
            setMealTotalAmountReturn(totalPrice);
            if (bookingFilterRef.current) {
                bookingFilterRef.current.handleRemoveCode();
            }
            return {
                ...prevState,
                [route]: { selectedMealsReturn: updatedMeals },
            };
        });
    };

    const removeMealReturn = (route, mealIndex) => {
        setSelectedMealsReturn((prevState) => {
            const currentMeals = prevState[route]?.selectedMealsReturn || [];
            const existingMealIndex = currentMeals.findIndex((m) => m.mealIndex === mealIndex);
            if (existingMealIndex < 0) return prevState;
            let updatedMeals;
            const existingMeal = currentMeals[existingMealIndex];
            const currentQty = existingMeal.Quantity || 1;

            if (currentQty > 1) {
                updatedMeals = [...currentMeals];
                updatedMeals[existingMealIndex] = { ...existingMeal, Quantity: currentQty - 1 };
            } else {
                updatedMeals = currentMeals.filter((m) => m.mealIndex !== mealIndex);
            }
            const totalPrice = Object.values({
                ...prevState,
                [route]: { selectedMealsReturn: updatedMeals },
            }).reduce((acc, r) => {
                return (
                    acc +
                    r.selectedMealsReturn.reduce(
                        (sum, m) => sum + m.Price * (m.Quantity || 1),
                        0
                    )
                );
            }, 0);
            setMealTotalAmountReturn(totalPrice);
            if (bookingFilterRef.current) {
                bookingFilterRef.current.handleRemoveCode();
            }
            return {
                ...prevState,
                [route]: { selectedMealsReturn: updatedMeals },
            };
        });
    };

    const getTotalSelectedBaggagesReturn = () =>
        Object.values(selectedBaggagesReturn).reduce(
            (sum, route) => sum + route.reduce((routeSum, baggage) => routeSum + (baggage.Quantity || 1), 0),
            0
        );

    const [selectedBaggagesReturn, setSelectedBaggagesReturn] = useState({});
    const [totalAmountReturn, setTotalAmountReturn] = useState(0);

    const addBaggageReturn = (routeIndex, baggage, amount) => {
        const totalSelected = getTotalSelectedBaggagesReturn();
        if (totalSelected >= totalSelectedTravellers) return;
        setSelectedBaggagesReturn((prev) => {
            const currentRouteBaggages = prev[routeIndex] || [];
            const existingIndex = currentRouteBaggages.findIndex(
                item => item.Weight === baggage.Weight && item.Price === baggage.Price
            );
            let updatedRouteBaggages;
            if (existingIndex >= 0) {
                updatedRouteBaggages = [...currentRouteBaggages];
                updatedRouteBaggages[existingIndex] = {
                    ...updatedRouteBaggages[existingIndex],
                    Quantity: (updatedRouteBaggages[existingIndex].Quantity || 1) + 1
                };
            } else {
                updatedRouteBaggages = [...currentRouteBaggages, { ...baggage, Quantity: 1 }];
            }
            return { ...prev, [routeIndex]: updatedRouteBaggages };
        });
        setTotalAmountReturn(prev => prev + amount);
    };

    const removeBaggageReturn = (routeIndex, baggage) => {
        setSelectedBaggagesReturn((prev) => {
            if (!prev[routeIndex]) return prev;
            const currentRouteBaggages = prev[routeIndex];
            const existingIndex = currentRouteBaggages.findIndex(
                item => item.Weight === baggage.Weight && item.Price === baggage.Price
            );
            if (existingIndex < 0) return prev;
            let updatedRouteBaggages;
            const existingBaggage = currentRouteBaggages[existingIndex];
            const currentQty = existingBaggage.Quantity || 1;
            if (currentQty > 1) {
                updatedRouteBaggages = [...currentRouteBaggages];
                updatedRouteBaggages[existingIndex] = {
                    ...existingBaggage,
                    Quantity: currentQty - 1
                };
            } else {
                updatedRouteBaggages = currentRouteBaggages.filter(
                    (_, index) => index !== existingIndex
                );
            }
            if (updatedRouteBaggages.length === 0) {
                const { [routeIndex]: _, ...remaining } = prev;
                return remaining;
            }
            return { ...prev, [routeIndex]: updatedRouteBaggages };
        });
        setTotalAmountReturn(prev => Math.max(prev - baggage.Price, 0));
    };

    const mealReturn = Object.values(selectedMealsReturn).flatMap(
        (item) => item.selectedMealsReturn
    );

    const baggagesReturn = Object.values(selectedBaggagesReturn).flatMap((baggageArray) =>
        baggageArray.map((baggage) => ({
            ...baggage,
        }))
    );

    const seatsRetrun = Object?.values(selectedSeatsReturn)
        .flat()
        .map(seat => ({ ...seat, Quantity: 1 }));

    const outputDataReturn = {
        meals: mealReturn,
        baggages: baggagesReturn,
        seats: seatsRetrun
    };

    const [couponId, setCouponId] = useState(null);
    const [applyDiscountShow, setApplyDiscountShow] = useState(false);
    const [totalAfterDiscount, setTotalAfterDiscount] = useState(0);
    const [discountAmountOffer, setDiscountAmountOffer] = useState(0);
    const fareDetail = flightDetails?.flightDetails?.fareRules?.after_discount_amount || 0;
    const totalPriceBaggages = fareDetail + totalAmount + mealTotalAmount + mealTotalAmountRetrun + totalAmountReturn + totalSeatsPrice + totalSeatsPriceReturn;
    const [convenienceCharge, setConvenienceCharge] = useState(null);
    const [calculatedFee, setCalculatedFee] = useState(0);
    const [finalTotal, setFinalTotal] = useState(0);

    const [swtFee, setSwtFee] = useState(0);
    const [convenienceChargeProceed, setConvenienceProceed] = useState(null);
    const [error, setError] = useState(null);
    const [applicableChargeData, setApplicableChargeData] = useState(null);

    const fetchConvenienceCharge = async () => {
        try {
            const params = { type: "charge", category: "flight" };
            const response = await getConvenienceCharge(params);
            setConvenienceCharge(response);
        } catch (err) {
            setError("Failed to fetch convenience charge data");
        }
    };

    useEffect(() => {
        fetchConvenienceCharge();
    }, []);


    let totalAmountWithSwt = totalPriceBaggages;

    useEffect(() => {
        if (convenienceCharge) {
            let calculatedFee = 0;
            let finalTotal = totalAmountWithSwt;
            const applicableCharge = convenienceCharge.find(
                (charge) =>
                    finalTotal >= charge.min_order_value &&
                    finalTotal <= charge.max_order_value
            );

            if (applicableCharge) {
                setApplicableChargeData(applicableCharge);
                if (applicableCharge.discount_type === "PERCENTAGE") {
                    calculatedFee = (finalTotal * parseFloat(applicableCharge.value)) / 100;
                } else if (applicableCharge.discount_type === "AMOUNT") {
                    calculatedFee = parseFloat(applicableCharge.value);
                }
            }
            finalTotal += calculatedFee;
            setFinalTotal(finalTotal)
            setCalculatedFee(calculatedFee);
        }
    }, [convenienceCharge, selectedMeals, selectedBaggages, flightDetails, selectedMealsReturn, selectedBaggagesReturn, selectedSeats, selectedSeatsReturn]);

    const [FlightOffersHideShow, setFlightOffersHideShow] = useState(false)

    const [skipAddons, setSkipAddons] = useState(null)
    const [convenienceChargeTotalFareModal, setConvenienceChargeTotalFareModal] = useState(false);

    const skipAddonAndPayNow = () => {
        setSelectedMeals({});
        setSelectedMealsReturn({});
        setSelectedBaggages([]);
        setSelectedBaggagesReturn([]);
        setMealTotalAmount(0);
        setTotalAmount(0);
        setMealTotalAmountReturn(0);
        setTotalAmountReturn(0);
        setSelectedSeats({});
        setSelectedSeatsReturn({});
        setTotalPrice({});
        setTotalPriceReturn({});
        setSkipAddons(true);
        setConvenienceChargeTotalFareModal(true);
    };

    const [collapseCard, setCollapseCard] = useState(true);
    const [collapseCardTravellers, setCollapseCardTravellers] = useState(true);

    return (
        <div>
            <section className='result_cntr ptb-30 ptb-md-70 pt-4'>
                <div className="container">
                    <h2 className='mb-2 mb-md-4'>Review your booking</h2>
                    <Row gutter="20">
                        <Col xl={17} lg={15} xs={24}>
                            <BookingFlight
                                getTotalSelectedBaggagesReturn={getTotalSelectedBaggagesReturn}
                                getTotalSelectedBaggages={getTotalSelectedBaggages}
                                errorMeelBaggegas={errorMeelBaggegas}
                                meelBaggegasData={meelBaggegasData}
                                location={location}
                                outputData={outputData}
                                outputDataReturn={outputDataReturn}
                                swtFee={swtFee}
                                convenienceCharge={convenienceCharge}
                                setConvenienceProceed={setConvenienceProceed}
                                flightDetails={flightDetails}
                                mealTotalAmount={mealTotalAmount}
                                loading={loading}
                                setSelectedBaggages={setSelectedBaggages}
                                selectedBaggages={selectedBaggages}
                                totalAmount={totalAmount}
                                totalPriceBaggages={totalPriceBaggages}
                                addBaggage={addBaggage}
                                removeBaggage={removeBaggage}
                                selectedMeals={selectedMeals}
                                totalSelectedTravellers={totalSelectedTravellers}
                                addMeal={addMeal}
                                removeMeal={removeMeal}
                                selectedMealsReturn={selectedMealsReturn}
                                mealTotalAmountRetrun={mealTotalAmountRetrun}
                                addMealReturn={addMealReturn}
                                removeMealReturn={removeMealReturn}
                                calculatedFee={calculatedFee}
                                finalTotal={finalTotal}
                                applicableChargeData={applicableChargeData}
                                couponId={couponId}
                                setCouponId={setCouponId}
                                applyDiscountShow={applyDiscountShow}
                                setApplyDiscountShow={setApplyDiscountShow}
                                discountAmountOffer={discountAmountOffer}
                                setDiscountAmountOffer={setDiscountAmountOffer}
                                totalAfterDiscount={totalAfterDiscount}
                                setTotalAfterDiscount={setTotalAfterDiscount}

                                selectedBaggagesReturn={selectedBaggagesReturn}
                                setSelectedBaggagesReturn={setSelectedBaggagesReturn}
                                totalAmountReturn={totalAmountReturn}
                                addBaggageReturn={addBaggageReturn}
                                removeBaggageReturn={removeBaggageReturn}
                                setFlightOffersHideShow={setFlightOffersHideShow}

                                setMealTotalAmount={setMealTotalAmount}
                                setTotalAmount={setTotalAmount}
                                setMealTotalAmountReturn={setMealTotalAmountReturn}
                                setTotalAmountReturn={setTotalAmountReturn}

                                setConvenienceChargeTotalFareModal={setConvenienceChargeTotalFareModal}
                                convenienceChargeTotalFareModal={convenienceChargeTotalFareModal}
                                skipAddonAndPayNow={skipAddonAndPayNow}
                                skipAddons={skipAddons}
                                setSkipAddons={setSkipAddons}

                                collapseCard={collapseCard}
                                setCollapseCard={setCollapseCard}
                                collapseCardTravellers={collapseCardTravellers}
                                setCollapseCardTravellers={setCollapseCardTravellers}
                                setSelectedMeals={setSelectedMeals}
                                setSelectedMealsReturn={setSelectedMealsReturn}

                                rowsByFlight={rowsByFlight}
                                setRowsByFlight={setRowsByFlight}
                                legends={legends}
                                setLegends={setLegends}
                                selectedSeats={selectedSeats}
                                setSelectedSeats={setSelectedSeats}
                                totalPrice={totalPrice}
                                setTotalPrice={setTotalPrice}
                                handleSeatClick={handleSeatClick}
                                totalSeatsPrice={totalSeatsPrice}

                                rowsByFlightReturn={rowsByFlightReturn}
                                setRowsByFlightReturn={setRowsByFlightReturn}
                                legendsReturn={legendsReturn}
                                setLegendsReturn={setLegendsReturn}
                                selectedSeatsReturn={selectedSeatsReturn}
                                setSelectedSeatsReturn={setSelectedSeatsReturn}
                                totalPriceReturn={totalPriceReturn}
                                setTotalPriceReturn={setTotalPriceReturn}
                                handleSeatClickReturn={handleSeatClickReturn}
                                totalSeatsPriceReturn={totalSeatsPriceReturn}

                            />
                        </Col>
                        <Col xl={7} lg={9} xs={24} className="d-none d-md-block">
                            <BookingFilter
                                ref={bookingFilterRef}
                                meelBaggegasData={meelBaggegasData}
                                errorMeelBaggegas={errorMeelBaggegas}
                                flightDetails={flightDetails}
                                loading={loading}
                                convenienceCharge={convenienceCharge}
                                swtFee={swtFee}
                                calculatedFee={calculatedFee}
                                finalTotal={finalTotal}
                                setSelectedBaggages={setSelectedBaggages}
                                selectedBaggages={selectedBaggages}
                                totalAmount={totalAmount}
                                totalPriceBaggages={totalPriceBaggages}
                                setTotalAmount={setTotalAmount}
                                addBaggage={addBaggage}
                                removeBaggage={removeBaggage}
                                totalSelectedTravellers={totalSelectedTravellers}
                                mealTotalAmount={mealTotalAmount}
                                couponId={couponId}
                                setCouponId={setCouponId}
                                applyDiscountShow={applyDiscountShow}
                                setApplyDiscountShow={setApplyDiscountShow}
                                discountAmountOffer={discountAmountOffer}
                                setDiscountAmountOffer={setDiscountAmountOffer}
                                totalAfterDiscount={totalAfterDiscount}
                                setTotalAfterDiscount={setTotalAfterDiscount}

                                totalAmountReturn={totalAmountReturn}
                                mealTotalAmountRetrun={mealTotalAmountRetrun}
                                FlightOffersHideShow={FlightOffersHideShow}
                                convenienceChargeTotalFareModal={convenienceChargeTotalFareModal}
                                totalSeatsPrice={totalSeatsPrice}
                                totalSeatsPriceReturn={totalSeatsPriceReturn}
                            />
                        </Col>
                    </Row>

                    <FlightNotFetch
                        messageData={messageData}
                        isModalOpenFlightNotFetch={isModalOpenFlightNotFetch}
                        setIsModalOpenFlightNotFetch={setIsModalOpenFlightNotFetch}
                    />
                </div>

            </section>

        </div>
    )
}

export default BookingDetailsTbo